import Swal from "sweetalert2";
import TableAHSF from "../../Components/TableAHSF"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetReportStageByID } from "../../Redux/Reducers/ReportStage/Stages";
import { useEffect, useState } from "react";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import InformationAdministrativeCosts from "./InformationAdministrativeCosts";
import PopupAHSF from "../../Components/PopupAHSF";
import CommentPopup from "./CommentPopup";
const FinancialSummaryShare = (props) => {
    const [PopupComponentEditStatus, setPopupComponentEditStatus] =
        useState(false);
    const [PopupComponentCommentStatus, setPopupComponentCommentStatus] =
        useState(false);
    const [PR_EstimatedBudgetForAdministrativeCostsId, setPR_EstimatedBudgetForAdministrativeCostsId] = useState(null)
    const dispatch = useDispatch();
    const stageGuid = useParams().stageGuid
    console.log(stageGuid, "skldkjskdjksjd");
    const BIEstimatedBudgetForAdministrativeCostsId = useSelector((state) => state.PRAdministrativeCostsReducers.PRAdministrativeCosts)

    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const reportStage = useSelector((state) => state.Stages.ReportsStagesById)
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];


    const RequestAccessor = [
        {
            KeyName: "typeName",
            ShowStatus: true,
            NmaeColumn: "-",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "totalValue",
            ShowStatus: true,
            NmaeColumn: " الإجمالي",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "totaltransfarestring",
            ShowStatus: true,
            NmaeColumn: "المناقلات",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "totalbrevousExchange",
            ShowStatus: true,
            NmaeColumn: "اجمالي الصرف حتى المرحلة السابقة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "currentExchange",
            ShowStatus: true,
            NmaeColumn: "اجمالي الصرف الحالي",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "remainingTotal",
            ShowStatus: true,
            NmaeColumn: "الاجمالي المتبقي",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        }
    ];

    const OtherMainBtns = [




    ];


    console.log(props.URLApi, "sssssssssddwdw");


    return (<>

        <>

            {
                props.URLApi ? <TableAHSF
                    culomEdite={culomEdite}
                    uniqueValue={props.uniqueValue
                    }
                    valueButtonAction={props.valueButtonAction}
                    URL={props.URLApi}
                    UrlBody={

                        props.UrlBody
                    }
                    staticKeyEdite={staticKeyEdite}
                    accessor={RequestAccessor}
                    titelTable={"ملخص البند"}
                    selectRowNumber={true}
                    checkBoksColumName="اختيار"
                    sort={true}
                    pagination={true}
                    AppStatus={true}
                    tableBtn={false}
                    sortTable={true}
                    keyNameSort={"dateCreate"}
                    dateKey="dateCreate"
                    dateformat="DD/MM/YYYY h:mm a"
                    arrayNameSort={["applicationNumber"]}
                    search={true}
                    openPopupState={false}
                    DropdownArrayFiltration={[]}
                    DropdownFiltration={false}
                    exportData={true}
                    checkBoks={false}
                    nameColumAction=""
                    total={false}
                    showColumAction={false}
                    arrayButton={OtherMainBtns}
                    ArrayNameDataColum={RequestsColumns}
                    columnKeyNameArray={[
                        { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                    ]}
                    PopupOPjectData={""}
                    popUpTitle={"معلومات الطلب"}
                // popUpBody2={[<ShowApplication addFun={true} />]}
                // popUpId2={"ShowApplicationpopUp"}
                // popUpBody2={[
                //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
                // ]}
                // handleCloseModal={handleCloseModal}
                // showModal={showPopUp}
                /> : <></>
            }



        </>
    </>)
}

export default FinancialSummaryShare;